import Api from "@/services/Api";
import BaseApi from "../../../services/baseApi";

class Servise_se {
    constructor() {
        this.entity = 'templateSmsManager';
    }




    getById(id) {
        return BaseApi({requiresAtuh: true})({
            method: 'GET',
            url: '/private/' + this.entity + '/view/?id='+id,
            headers: {'Content-Type': 'application/json'},
        })
        }


    getPage() {
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            url: '/private/' + this.entity + '/requestList',
            headers: {'Content-Type': 'application/json'},
        })

    }

    save(model) {
        return Api.save(this.entity,model)
    }

    confirm(id,descripiton){
        let formData = new FormData();
        formData.set("descripiton", descripiton)
        formData.set("id", id)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/' + this.entity + '/confirm',
            headers: {'Content-Type': 'application/json'},
        })
    }
    unConfirm(id,descripiton){
        let formData=new FormData();
        formData.set("descripiton",descripiton)
        formData.set("id", id)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:formData,
            url: '/private/'+this.entity+'/unConfirm',
            headers: {'Content-Type': 'application/json'},
        })
    }



}
export default new Servise_se();

